import React, { useState } from 'react'

// Components
import CartItem from './CartItem'
import CartTotal from './CartTotal'
import ReviewOrder from '../ReviewOrder/ReviewOrder'

// Material UI
import AppBar from '@material-ui/core/AppBar'
import Drawer from '@material-ui/core/Drawer'
import IconButton from '@material-ui/core/IconButton'
import Toolbar from '@material-ui/core/Toolbar'
import Typography from '@material-ui/core/Typography'

// Icons
import ClearIcon from '@material-ui/icons/Clear'

// Translation
import { Language } from '../../Translation'

// Redux
import { connect } from 'react-redux'

const Cart = ({ cartData, storeData, clientData, toggleDrawer }) => {

    const { cart } = cartData
    const { store } = storeData
    const { language } = clientData

    const [openDrawer, setOpenDrawer] = useState(false)

    const handleSubTotal = () => {
        return cart.reduce((sum, item) => sum + (item.quantity * (item.price + item.priceTotalOptions + item.priceTotalIngredients)), 0)
    }

    const handleCoupon = () => {
        return store.DISCOUNT_PERCENTAGE ? handleSubTotal() * (store.DISCOUNT_PERCENTAGE / 100) : 0
    }

    const handleTaxCalculation = () => {

        let tps = store.TAX1_VALUE
        let tvq = store.TAX2_VALUE
        let subtotal = handleSubTotal() - handleCoupon()
        return ((subtotal * tps) + (subtotal * tvq))

    }

    const handleTotal = () => {
        return (handleSubTotal() - handleCoupon()) + handleTaxCalculation()
    }

    const renderHeader = (title) => {

        return (
            <>
                <AppBar style={{ position: 'static', backgroundColor: "#003366" }}>
                    <Toolbar>
                        <IconButton style={{ marginLeft: -20, color: "white" }} onClick={toggleDrawer} color="default" aria-label="ArrowBackIcon">
                            <ClearIcon />
                        </IconButton>
                        <Typography variant="h6">{title}</Typography>
                    </Toolbar>
                </AppBar>
            </>
        )

    }

    if (!cart.length) {
        return (
            <>
                {renderHeader(Language.CartHeader[language])}
                <h2 style={{ textAlign: "center" }}>{Language.CartIsEmpty[language]}</h2>
            </>
        )
    }

    return (
        <>
            {renderHeader(Language.CartHeader[language])}
            <div style={{ marginBottom: 195 }}>
                {cart.map((cartItem, index) =>
                    <CartItem
                        key={index}
                        cartItem={cartItem}
                    />
                )
                }
            </div>
            <CartTotal
                handleSubTotal={handleSubTotal}
                handleCoupon={handleCoupon}
                handleTaxCalculation={handleTaxCalculation}
                handleTotal={handleTotal}
                toggleDrawer={setOpenDrawer}
            />
            <Drawer open={openDrawer} anchor="right">
                <ReviewOrder toggleDrawer={setOpenDrawer} handleSubTotal={handleSubTotal} handleTotal={handleTotal} />
            </Drawer>
        </>
    )
}

const mapStateToProps = state => {
    return {
        cartData: state.cartData,
        storeData: state.storeData,
        clientData: state.clientData
    }
}

export default connect(mapStateToProps)(Cart)